import { getAudio } from "@/audio";

const COVER_PEAK = 0.12;
const SWELL_S = 6;
let cover = null;

const brown = (ctx, secs) => {
  const b = ctx.createBuffer(2, ctx.sampleRate * secs, ctx.sampleRate);
  for (let c = 0; c < 2; c++) {
    const d = b.getChannelData(c);
    let last = 0;
    for (let i = 0; i < d.length; i++) { last = (last + 0.02 * (Math.random() * 2 - 1)) / 1.02; d[i] = last * 3.2; }
  }
  return b;
};

export const startHandover = (seconds, onSwell) => {
  stopHandover();
  const { ctx } = getAudio();
  const t = ctx.currentTime;
  const len = Math.max(SWELL_S + 2, seconds);
  const bus = ctx.createGain();
  bus.gain.setValueAtTime(0, t);
  bus.gain.linearRampToValueAtTime(COVER_PEAK, t + SWELL_S);
  bus.gain.linearRampToValueAtTime(0, t + len);
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 700;
  bus.connect(lp).connect(ctx.destination);
  const noise = ctx.createBufferSource();
  noise.buffer = brown(ctx, 4);
  noise.loop = true;
  const ng = ctx.createGain();
  ng.gain.value = 0.6;
  noise.connect(ng).connect(bus);
  const oscs = [110, 164.81, 220, 277.18].map((f, i) => {
    const o = ctx.createOscillator();
    o.type = i % 2 ? "triangle" : "sine";
    o.frequency.value = f;
    o.detune.value = (i - 1.5) * 4;
    const g = ctx.createGain();
    g.gain.value = 0.09;
    o.connect(g).connect(bus);
    return o;
  });
  [noise, ...oscs].forEach((n) => { n.start(t); n.stop(t + len + 0.2); });
  const swell = setTimeout(onSwell, (SWELL_S - 1) * 1000);
  cover = { bus, swell };
  window.__sleepHandover = { at: Date.now(), seconds: len };
};

export const stopHandover = () => {
  if (!cover) return;
  const { ctx } = getAudio();
  clearTimeout(cover.swell);
  cover.bus.gain.cancelScheduledValues(ctx.currentTime);
  cover.bus.gain.setTargetAtTime(0, ctx.currentTime, 0.3);
  cover = null;
};
